import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {Course} from 'src/app/models/course.model';
import {CourceService} from 'src/app/services/cource.service';
import {ArchiveService} from 'src/app/services/archive.service';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CourseCategoryService} from 'src/app/services/course-category.service';
import {CourseCategory} from 'src/app/models/course-category.model';
import {ActivatedRoute, Router} from '@angular/router';


@Component({
  selector: 'app-program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.css'],
})
export class ProgramComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;

  breakpoint: number;

  showSpinner: boolean = true;
  courses: Course[] = [];
  courseSubscription$: Subscription;
  archiveSubscription$: Subscription;
  pagedList: Course[] = []; // All courses (unfiltered)
  filteredList: Course[] = []; // Currently filtered courses
  length: number = 0;
  pageSize: number = 6;
  pageSizeOptions: number[] = [3, 6, 9, 12];
  categories: CourseCategory[] = [];
  categorySubscription$: Subscription;
  rowHeight: string;
  mobileViewForFilters: boolean = true;
  desktopViewrForFIlters: boolean = false;
  toggleFilterListDisplay: boolean = false;
  toggleDownIcon: boolean = true;
  toggleUpIcon: boolean = false;
  displayName: string = 'Alle';
  selectedId: string | number = 'all';
  showAlle: boolean = false;
  preCategoryData: any = '';
  selectedAll: boolean = true;
  paramsObject: any = {};
  startPage: number = 0;
  endPage: number = 6;
  pageLength: number = 10;
  lockNextbutton: boolean = true;
  fullTitle: string = '';
  public _SelectedYear: string | null = '';


  constructor(
    private courseService: CourceService,
    private archiveService: ArchiveService,
    private courseCategoryService: CourseCategoryService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this._SelectedYear = localStorage.getItem('selectedYear');
    window.scrollTo(0, 0);

    this.route.queryParamMap
      .subscribe(params => {
        const previousYear = this._SelectedYear;
        this._SelectedYear = params.get('year');

        // Check if year has changed
        const yearChanged = previousYear !== this._SelectedYear;

        const newPageSize = params.get('pageSize') ? parseInt(params.get('pageSize')!) : this.pageSize;
        if (newPageSize) {
          this.pageSize = newPageSize;
        }
        this.paramsObject = {...params.keys, ...params};

        // Only reset pagination if year has changed
        if (yearChanged) {
          // Reset to first page when year changes
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {page: 0, pageSize: this.pageSize},
            queryParamsHandling: 'merge'
          });
        }

        // Determine if we're in archive mode based on the route
        // Check if the current route contains 'archiv' to determine archive mode
        const isArchiveRoute = this.router.url.includes('archiv');

        if (isArchiveRoute) {
          // Archive mode: use archive service
          if (this._SelectedYear) {
            // Load courses for the selected year
            this.archiveService.getArchivedCoursesByYear(this._SelectedYear);
          } else {
            // Load all archived courses when no specific year is selected
            this.archiveService.loadAllArchivedCourses();
          }

          // Unsubscribe from any previous archive subscription to avoid memory leaks
          if (this.archiveSubscription$) {
            this.archiveSubscription$.unsubscribe();
          }

          // Subscribe to archive service updates
          this.archiveSubscription$ = this.archiveService.archiveCourses$.subscribe(
            (archiveCourses: Course[]) => {
              this.courses = [
                ...archiveCourses.reverse().map((x) => JSON.parse(JSON.stringify(x))),
              ];
              this.processCourses();
            }
          );
        } else {
          // Regular program mode: use course service to load current/upcoming courses
          // Clear existing courses before loading new ones to prevent stale data
          this.courseService.courses = [];
          this.courseService.getCurrentCourses();

          // Unsubscribe from any previous course subscription to avoid memory leaks
          if (this.courseSubscription$) {
            this.courseSubscription$.unsubscribe();
          }

          // Subscribe to course service updates for regular program mode
          this.courseSubscription$ = this.courseService.courseSubject$.subscribe(
            (response: Course[]) => {
              this.courses = [
                ...response.reverse().map((x) => JSON.parse(JSON.stringify(x))),
              ];
              this.processCourses();
            }
          );
        }
      });

    this.courseCategoryService.getAllCategorys();
    this.categorySubscription$ = this.courseCategoryService.courseCategorySubject$
      .subscribe(
        (response: CourseCategory[]) => {
          this.preCategoryData = response;
          this.categories = this.preCategoryData.map((cat: any) => {
            return {
              ...cat,
              selected: false,
            };
          });
        }
      );
    this.rowHeight = this.calculateRowHeight();

    if (window.innerWidth <= 576) {
      this.breakpoint = 1;
    } else if (window.innerWidth <= 992) {
      this.mobileViewForFilters = true;
      this.desktopViewrForFIlters = false;
      this.breakpoint = 1;
    } else if (window.innerWidth <= 1200) {
      this.breakpoint = 2;
    } else if (window.innerWidth <= 1400) {
      this.breakpoint = 2;
    } else {
      this.breakpoint = 3;
    }
    if (window.innerWidth > 992) {
      this.mobileViewForFilters = false;
      this.desktopViewrForFIlters = true;
    }
    this.courseSubscription$ = this.courseService.courseSubject$.subscribe(
      (response: Course[]) => {
        this.courses = [
          ...response.reverse().map((x) => JSON.parse(JSON.stringify(x))),
        ];
        this.courses = this.courses.map((course) => {
          let subDes = course.content.replace(/<(.+?)>/g, '');
          if (subDes.length > 200) {
            subDes = subDes.substring(0, 200);
            subDes = subDes.substring(0, subDes.lastIndexOf(' '));
            subDes += ' ...';
          }
          course.content = subDes;
          course.content = course.content.substring(0, 200);
          this.fullTitle = course.title;
          course.fullTitle = this.fullTitle;
          course.title =
            course.title.length > 40
              ? course.title.substring(0, 40) + ' ...'
              : course.title;
          let category = this.categories.find(
            (cat) => cat.id === course.category_id
          );

          if (category) {
            course.category_name = category.name;
          }
          return course;
        });
        this.pagedList = this.courses;
        this.filteredList = [...this.pagedList]; // Initialize filtered list with all courses
        this.applyPagination();
        this.length = this.filteredList.length;
        this.showSpinner = false;
        if (this.paramsObject?.params?.id) {
          this.filterCategory(
            this.paramsObject?.params?.id === 'all'
              ? this.paramsObject?.params?.id
              : parseInt(this.paramsObject?.params?.id)
          );
        } else {
          // If no filter is applied, just apply pagination to the full list
          this.filteredList = [...this.pagedList];
          this.applyPagination();
        }
      }
    );
  }


  onDropDownToggle(event: any) {
    this.toggleFilterListDisplay = !this.toggleFilterListDisplay;
    this.toggleDownIcon = !this.toggleDownIcon;
    this.toggleUpIcon = !this.toggleUpIcon;

    if (this.toggleFilterListDisplay === false) {
      this.courseCategoryService.getAllCategorys();
      this.categorySubscription$ =
        this.courseCategoryService.courseCategorySubject$.subscribe(
          (response: CourseCategory[]) => {
            this.preCategoryData = response;
            this.categories = this.preCategoryData.map((cat: any) => {
              return {
                ...cat,
                selected: false,
              };
            });
          },
          (error) => {
            console.log('An error occured: ' + error);
          }
        );
    }

    this.categories = this.categories.filter((cat) => {
      this.showAlle = this.displayName !== 'Alle';
      return this.displayName !== cat.name;
    });
  }

  calculateRowHeight(): string {
    return window.innerWidth <= 500 ? '35rem' : '28rem';
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }

  OnPageChange(event: PageEvent) {
    console.log('--------------------------------------,event', event)
    this.pageSize = event.pageSize;

    // Check if we're in archive route
    const isArchiveRoute = this.router.url.includes('archiv');
    const navigationUrl = isArchiveRoute ? '/programm/archiv' : '/program';

    // Include the year in the query params if we're in archive route and have a selected year
    const queryParams: any = {page: event.pageIndex, pageSize: event.pageSize};
    if (isArchiveRoute && this._SelectedYear) {
      queryParams.year = this._SelectedYear;
    }

    this.router.navigate([navigationUrl], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });

    // Update the displayed courses based on the current filtered list
    // Apply pagination immediately with the new page size
    this.applyPagination();
  }

  public filterCategory(id: any): void {
    if (this.toggleFilterListDisplay) {
      this.courseCategoryService.getAllCategorys();
      this.categorySubscription$ =
        this.courseCategoryService.courseCategorySubject$.subscribe(
          (response: CourseCategory[]) => {
            this.preCategoryData = response;
            this.categories = this.preCategoryData.map((cat: any) => {
              return {
                ...cat,
                selected: false,
              };
            });
          },
          (error) => {
            console.log('An error occured: ' + error);
          }
        );
    }

    // Determine if we're in archive mode based on the route
    const isArchiveRoute = this.router.url.includes('archiv');

    if (isArchiveRoute) {
      // Archive mode: use archive service for filtering
      this.archiveService.filterByCategory(id);
      // The subscription in ngOnInit will handle the update automatically
    } else {
      // Regular program mode: use the original filtering logic
      if (id === 'all') {
        this.filteredList = [...this.pagedList]; // Reset to all courses
        this.displayName = 'Alle';
        this.showAlle = false;
        this.selectedAll = true;

        this.categories = this.preCategoryData.map((cat: any) => {
          return {
            ...cat,
            selected: false,
          };
        });
      } else {
        this.categories = this.preCategoryData.map((cat: any) => {
          this.selectedAll = false;
          if (cat?.id === id) {
            return {
              ...cat,
              selected: true,
            };
          }
          return {
            ...cat,
            selected: false,
          };
        });

        // Filter the courses and capture the category name from the first match
        const filteredCourses = this.pagedList.filter((course) => {
          return course.category_id?.toString() === id.toString();
        });

        // Set display name from the first filtered course if available
        if (filteredCourses.length > 0) {
          this.displayName = filteredCourses[0].category_name as string;
        }

        this.filteredList = filteredCourses;
        this.toggleFilterListDisplay = false;
        this.toggleDownIcon = true;
        this.toggleUpIcon = false;
        // Set selectedId to the id of the first course in the category if available
        if (filteredCourses.length > 0) {
          this.selectedId = filteredCourses[0].id as number;
        }
      }

      // Reset to first page when filtering changes
      const queryParams: any = {page: 0, pageSize: this.pageSize};
      // Only add year param if we're in archive route
      if (isArchiveRoute && this._SelectedYear) {
        queryParams.year = this._SelectedYear;
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge'
      });

      // Update pagination after filtering
      setTimeout(() => {
        this.applyPagination();
        this.length = this.filteredList.length;

        // Update paginator properties to reflect the new filtered list
        if (this.paginator) {
          this.paginator.pageIndex = 0; // Reset paginator to first page
        }

        // Show next button if there are more items than the page size
        this.lockNextbutton = this.filteredList.length > this.pageSize;
      }, 0);
    }
  }

  onResize(event: any) {
    if (event.target.innerWidth <= 576) {
      this.breakpoint = 1;
    } else if (event.target.innerWidth <= 992) {
      // TURN FALSE DESKTOP VERSION AND TRUE MOBILE VERSION
      this.mobileViewForFilters = true;
      this.desktopViewrForFIlters = false;
      this.breakpoint = 1;
    } else if (event.target.innerWidth <= 1200) {
      this.breakpoint = 2;
    } else if (event.target.innerWidth <= 1400) {
      this.breakpoint = 2;
    } else {
      this.breakpoint = 3;
    }
    // TURN TRUE DESKTOP VERSION AND FALSE MOBILE VERSION
    if (window.innerWidth > 992) {
      this.mobileViewForFilters = false;
      this.desktopViewrForFIlters = true;
    }
  }

  public handleNavigateDetailCourse(couseId: number | undefined): void {
    // Check if we're in archive route
    const isArchiveRoute = this.router.url.includes('archiv');

    if (isArchiveRoute) {
      // If in archive route, navigate to archive course detail
      this.router.navigate(['/programm/archiv/courses', couseId], {queryParams: {year: this._SelectedYear}});
    } else {
      // Otherwise navigate to regular course detail
      this.router.navigate(['/courses', couseId]);
    }
  }

  ngAfterViewInit() {
    // Update paginator after view is initialized
    if (this.paginator) {
      const currentPageIndex = this.route.snapshot.queryParamMap.get('page') ?
        parseInt(this.route.snapshot.queryParamMap.get('page')!) : 0;
      this.paginator.pageIndex = currentPageIndex;
    }
  }

  ngOnDestroy(): void {
    if (this.courseSubscription$) {
      this.courseSubscription$.unsubscribe();
    }
    if (this.archiveSubscription$) {
      this.archiveSubscription$.unsubscribe();
    }
    if (this.categorySubscription$) {
      this.categorySubscription$.unsubscribe();
    }
  }

  private applyPagination() {
    // Get current page from query params
    const currentPageIndex = this.route.snapshot.queryParamMap.get('page') ?
      parseInt(this.route.snapshot.queryParamMap.get('page')!) : 0;
    const startIndex = currentPageIndex * this.pageSize;
    const endIndex = Math.min(startIndex + this.pageSize, this.filteredList.length);

    // Update the displayed courses
    this.courses = this.filteredList.slice(startIndex, endIndex);
    this.length = this.filteredList.length;

    // Update the paginator if it exists (after view initialization)
    if (this.paginator) {
      this.paginator.pageIndex = currentPageIndex;
    }
  }

  private processCourses() {
    this.courses = this.courses.map((course) => {
      let subDes = course.content.replace(/<(.+?)>/g, '');
      if (subDes.length > 200) {
        subDes = subDes.substring(0, 200);
        subDes = subDes.substring(0, subDes.lastIndexOf(' '));
        subDes += ' ...';
      }
      course.content = subDes;
      course.content = course.content.substring(0, 200);
      this.fullTitle = course.title;
      course.fullTitle = this.fullTitle;
      course.title =
        course.title.length > 40
          ? course.title.substring(0, 40) + ' ...'
          : course.title;
      let category = this.categories.find(
        (cat) => cat.id === course.category_id
      );

      if (category) {
        course.category_name = category.name;
      }
      return course;
    });
    this.pagedList = this.courses;
    this.filteredList = [...this.pagedList]; // Initialize filtered list with all courses
    this.applyPagination();
    this.length = this.filteredList.length;
    this.showSpinner = false;
    if (this.paramsObject?.params?.id) {
      this.filterCategory(
        this.paramsObject?.params?.id === 'all'
          ? this.paramsObject?.params?.id
          : parseInt(this.paramsObject?.params?.id)
      );
    } else {
      // If no filter is applied, just apply pagination to the full list
      this.filteredList = [...this.pagedList];
      this.applyPagination();
    }
  }

}
